<template>
    <div class="vh-100">
        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left" @click="backtolistKasbon">
                    <div class="header-item">
                        <img src="../../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Detail Kasbon</div>
                <div class="header-top--right">
                    <div class="header-item"></div>
                </div>
            </div>
        </div>
        <!-- CONTENT -->
        <div class="content-wrapper main-page">
            <div class="m-t-16 m-d-16 p-x-20 w-limit">
                <div class="d-flex justify-content-between">
                    <div class="f-16 f-semi">{{namakaryawan_kasbondetail}}</div>

                    <!--
                    ## statuses class
                    .badge.color-red = belum lunas
                    .badge.color-yellow = cicilan
                    .badge.color green = lunas
                    -->
                    <div class="badge color-green">Lunas</div>
                </div>
                <div class="m-d-16">
                    <div class="f-13  f-c-midgrey" v-if="this.statusoutletdetailkasbon==='true'"><b>Kasir</b> {{namaoutletdetailkasbon}}</div>
                    <div class="f-13  f-c-midgrey" v-if="this.statusworkshopdetailkasbon==='true'"><b>Workshop</b> {{namaworkshopdetailkasbon}}</div>
                    <div class="f-13  f-c-midgrey" v-if="this.statuskurirdetailkasbon==='true'" id="statuskurirx"><b>Kurir</b></div>
                </div>
            </div>

            <div class="separator-line-dot w-limit"></div>

            <div class="w-limit p-x-20 p-y-16">
                <div id="tgl-kasbon" class="d-flex justify-content-between">
                    <div class="f-16 f-c-midgrey">Tgl Kasbon</div>
                    <div class="f-16">{{date_lunas_kasbondetail}}</div>
                </div>
                <div id="tgl-lunas" class="m-t-8 d-flex justify-content-between">
                    <div class="f-16 f-c-midgrey">Tgl Lunas</div>
                    <div class="f-16">{{waktu_pembayaraan_kasbon_detail}}</div>
                </div>

                <div class="separator-line-dot m-x-min m-t-16 m-d-16" v-if="statusriwayatbayar_detail_kasbon===1"></div>

                <div id="total-kasbon" class="m-t-8 d-flex justify-content-between">
                    <div class="f-16 f-c-midgrey">Total Kasbon</div>
                    <div class="f-16 f-semi">Rp {{nominal_detailkasbon}}</div>
                </div>
                <div class="m-t-8" v-if="statusriwayatbayar_detail_kasbon===1">
                    <div class="f-c-blue f-14 f-semi m-r-4" @click="riwayatcicil(dataidkasbon.idkasbon,dataidkasbon.idkaryawankasbon)">
                        Riwayat Cicilan
                        <img src="../../../assets/icons/chevron-right1.svg" height="14px" alt="">
                    </div>
                </div>
            </div>

            <div class="separator-line-dot w-limit"></div>

            <div class="w-limit p-x-20 p-y-16">
                <div class="f-16 f-c-midgrey">Keterangan</div>
                <div class="f-16">{{keterangankaryawan_kasbondetail}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DetailKasbon",
        props:['dataidkasbon'],
        data(){
            return{
                namaworkshopdetailkasbon:'',
                namaoutletdetailkasbon:'',
                statusoutletdetailkasbon:'',
                statusworkshopdetailkasbon:'',
                statuskurirdetailkasbon:'',
                namakaryawan_kasbondetail:'',
                detailkasbondetail:{},
                idkasbon_detail:'',
                idkaryawan_kasbondetail:'',
                keterangankaryawan_kasbondetail:'',
                nominal_detailkasbon:'',
                date_lunas_kasbondetail:'',
                waktu_pembayaraan_kasbon_detail:'',
                statuspelunasandetailkasbon:0,
                statusriwayatbayar_detail_kasbon:0,
                idkategori_kasbon_detail:'',
                tipepembayaraan_kasbon_detail:'0',
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
        mounted() {
            this.getDetailkasbon()

            this.backButtonPressed(this.backtolistKasbon)
        },
        methods:{
            riwayatcicil(id,idkaryawan){
                this.$emit('gotoriwayatcicilan',{idkaryawan: idkaryawan,idkasbon: id, islunas: 1})
            },
            backtolistKasbon(){
                this.$emit('backtolistkasbon')
            },

            // <-- Fungsi Formatrupiah nominal create bayar kasbon (Belum Bayar)-->

            inputnominalDetailBayarkasbonLunas(){
                var handlecicil = this.nominal_detailkasbon;
                var hasilcicil = handlecicil.replace(/[^0-9]+/,'');
                this.nominal_detailkasbon=hasilcicil;
                this.formatrupiahnominalDetailkasbonLunas();
            },

            formatrupiahnominalDetailkasbonLunas(){
                var rupiahcicil = this.nominal_detailkasbon;
                var formattedrupiahcicil = this.newrupiahnominalDetailkasbonLunas(rupiahcicil);
                this.nominal_detailkasbon=formattedrupiahcicil;
            },

            newrupiahnominalDetailkasbonLunas(angka, prefix){
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^,\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            // <-- Fungsi Get Detail -->

            async getDetailkasbon() {
                this.namaworkshopdetailkasbon = '';
                this.namaoutletdetailkasbon='';
                this.statusoutletdetailkasbon='false';
                this.statusworkshopdetailkasbon='false';
                this.statuskurirdetailkasbon='false';
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_karyawan_kasbon?idkasbon=' + this.dataidkasbon.idkasbon + '&idkaryawan=' + this.dataidkasbon.idkaryawankasbon,this.requestHeaders);
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.inputnominalDetailBayarkasbonLunas()
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide();
                            var detailkasbons = response.data.data.detail;
                            var data = response.data.data;
                            var lenght_potbay = detailkasbons.kasbon_bayar.length;
                            this.namakaryawan_kasbondetail = detailkasbons.karyawan.nama;
                            this.idkaryawan_kasbondetail = detailkasbons.karyawan.idkaryawan;
                            this.idkategori_kasbon_detail = detailkasbons.id;
                            this.keterangankaryawan_kasbondetail = detailkasbons.keterangan;
                            var nominal = detailkasbons.nominal;
                            var toRp = this.newrupiahnominalDetailkasbonLunas(nominal.toString());
                            this.nominal_detailkasbon = toRp;
                            this.date_lunas_kasbondetail = data.waktu_kasbon;
                            this.waktu_pembayaraan_kasbon_detail = data.waktu_pembayaran_terakhir;
                            this.statuspelunasandetailkasbon = detailkasbons.status_pelunasan;
                            if(lenght_potbay>1){
                                this.statusriwayatbayar_detail_kasbon = 1;
                            }
                            if (detailkasbons.karyawan.daftar_karyawan_outlet != null) {
                                this.namaoutletdetailkasbon = detailkasbons.karyawan.daftar_karyawan_outlet.outlet.nama;
                                this.statusoutletdetailkasbon = "true";

                            }
                            if (detailkasbons.karyawan.daftar_karyawan_workshop != null) {
                                this.namaworkshopdetailkasbon = detailkasbons.karyawan.daftar_karyawan_workshop.workshop.nama;
                                this.statusworkshopdetailkasbon = "true";
                            }

                            if (detailkasbons.karyawan.daftar_karyawan_kurir != null) {
                                this.statuskurirdetailkasbon = "true";
                            }

                        }
                    }

                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
                }
            },
        }
    }
</script>

<style scoped>

</style>